export const TABS_GAP = 4;
export const MAX_TAB_NAME_LENGTH = 40;
